module.exports = __webpack_public_path__ + "img/chef_retraining.022762c6.webp";